export default __webpack_public_path__ + "static/media/christie.df9e9b8b.jpg";